module.exports = __webpack_public_path__ + "assets/img/24_430_big.30a2896a.jpg";